const routes = [
  {
    path: '/accountgroup', //修改
    name: 'accountgroup',
    component: () => import('@src/modules/role/main'),
    meta: {
      requireAuth: false,
      routerAlive: true
    },
    children: [
      {
        path: '/accountgroup', // 管理
        name: 'accountgroupIndex',
        component: () => import('@src/modules/role/accountgroup'),
        meta: {
          requireAuth: false,
          routerAlive: true
        },
      },
    ],
  },
]

export default routes
